import {DispatchApi} from "../../core/dispatch/dispatch";
import {useToken} from "../../state/UserContextProvider";

export type NamespaceItem = {
    key: string;
    name: string;
};

export type AccountItem = {
    key: string;
    namespace: string;
    name: string;
};

export type UserListItem = {
    id: number;
    email: string;
    firstName: string;
    lastName: string;
    namespace: string;
    accountKey: string;
    roles: string[] | null;
};

export type AccountOption = {
    accountKey: string;
    namespace: string;
};

export type AddUserOptions = {
    accounts: AccountOption[];
    roles: string[];
};

class AdminApi extends DispatchApi {
    constructor(token: string | undefined | null) {
        super(token, "admin", false, false);
    }

    async listNamespaces(): Promise<NamespaceItem[]> {
        return this.dispatch<NamespaceItem[]>("listNamespaces");
    }

    async updateNamespace(key: string, name: string): Promise<void> {
        await this.dispatch("updateNamespace", {key, name});
    }

    async listAccounts(): Promise<AccountItem[]> {
        return this.dispatch<AccountItem[]>("listAccounts");
    }

    async updateAccount(key: string, name: string): Promise<void> {
        await this.dispatch("updateAccount", {key, name});
    }

    async listUsers(): Promise<UserListItem[]> {
        return this.dispatch<UserListItem[]>("listUsers");
    }

    async addUser(email: string, password: string, namespace: string, accountKey: string, roles: string[]): Promise<void> {
        await this.dispatch("addUser", {email, password, namespace, accountKey, roles});
    }

    async getAddUserOptions(): Promise<AddUserOptions> {
        return this.dispatch<AddUserOptions>("getAddUserOptions");
    }

    async updateUser(userId: number, firstName: string, lastName: string): Promise<void> {
        await this.dispatch("updateUser", {userId, firstName, lastName});
    }

    async updateUserRoles(userId: number, roles: string[]): Promise<void> {
        await this.dispatch("updateUserRoles", {userId, roles});
    }
}

export function useAdminApi() {
    return new AdminApi(useToken());
}

export const ADMIN_NAMESPACES_KEY = "admin-namespaces";
export const ADMIN_ACCOUNTS_KEY = "admin-accounts";
export const ADMIN_USERS_KEY = "admin-users";
export const ADMIN_ADD_USER_OPTIONS_KEY = "admin-add-user-options";
